import React, {memo, useCallback, useMemo} from 'react';
import {useHistory} from 'react-router-dom';

import './index.scss';

import weatherIcon0 from '../../assets/images/icons/header/0.png';
import weatherIcon1 from '../../assets/images/icons/header/1.png';
import weatherIcon2 from '../../assets/images/icons/header/2.png';
import weatherIcon3 from '../../assets/images/icons/header/3.png';
import weatherIcon4 from '../../assets/images/icons/header/4.png';
import weatherIcon5 from '../../assets/images/icons/header/5.png';
import weatherIcon6 from '../../assets/images/icons/header/6.png';
import weatherIcon7 from '../../assets/images/icons/header/7.png';
import weatherIcon8 from '../../assets/images/icons/header/8.png';
import weatherIcon9 from '../../assets/images/icons/header/9.png';
import weatherIcon10 from '../../assets/images/icons/header/10.png';

import {DateTime} from '../DateTime';
import {useSelector} from 'react-redux';
import {onClickHandler} from '../../utils/onclick';
import {useRPC} from '../../hooks/rpc';
import {useMessage} from '../../hooks/message';

const weatherIcons = [
    weatherIcon0,
    weatherIcon1,
    weatherIcon2,
    weatherIcon3,
    weatherIcon4,
    weatherIcon5,
    weatherIcon6,
    weatherIcon7,
    weatherIcon8,
    weatherIcon9,
    weatherIcon10,
];

export const Header = memo(function Header({locked}: { locked: boolean }) {
    const history = useHistory();
    const [rpc] = useRPC();
    const {success} = useMessage();
    // const location = useLocation();
    // const question = useQuestion();
    // const [rpc] = useRPC();
    // const dispatch = useDispatch();
    // const role = useSelector(state => state.ui.role);

    const {icon, temperature} = useSelector(state => state.temperature);

    const onClick = useCallback(() => {
        // if (role != null && role !== 'default') {
        //     e.preventDefault();
        //     if (location.pathname.includes('/settings')) {
        //         question('Çıkış yapmak ister misiniz?', () => {
        //             rpc.doLogout();
        //             dispatch(clearUserAction());
        //             removeSession();
        //             history.push('/');
        //         }, () => {
        //             history.push('/');
        //         }, {text: 'Evet', timed: false}, true);
        //         return;
        //     }
        // }

        history.push('/');
    }, [history]);

    const onDateTimeClick = useCallback(() => {
        rpc.broadcastTimeAndWeather();
        rpc.getRTC();
        success("", true)
    }, [rpc]);

    return (
        <div className={'header' + (locked ? ' blur' : '')}>
            <span className="logo" {...onClickHandler(onClick)}>
                inohom
            </span>
            <div className="menu" {...onClickHandler(onDateTimeClick)}>
                <div className="weather">
                    <img className="weather-icon" src={weatherIcons[icon] || weatherIcons[0]} alt="weather"/>
                    <span className="weather-text">{temperature.toString()} <small>°C</small></span>
                </div>
            </div>
            <div className="menu" {...onClickHandler(onDateTimeClick)}>
                <DateTime/>
            </div>
        </div>
    );
});
